import Cookies from 'js-cookie';

export const inviteTokenForModel = (idModel: string): string | null => {
  return Cookies.get(`invite-token-${idModel}`) || null;
};
